// Instructions
// To make it possible for the config to find the field,
// the component must have an id with the same identifier
// as in the config!
import React from 'react'

import {
  createCalculatingComponent,
  createComponent,
  createDropDownComponent,
  createLabel,
  createLoadingComponent,
} from './createElements'

type Props = {
  className?: string
  component: JSX.Element
  config: any
  errorMsg?: JSX.Element | null
  label?: JSX.Element
  loadingComponent?: JSX.Element
  isLoading?: boolean
  isCalculating?: boolean
  isRequired?: boolean
}

export const ConfigurableComponent: React.FC<Props> = ({
  className = '',
  component,
  config,
  errorMsg,
  label,
  loadingComponent,
  isLoading = false,
  isCalculating = false,
  isRequired,
}) => {
  const id = component.props.id
  const enabled = config[id]?.enabled !== false

  const newLabel = createLabel(config[id], label, isRequired)
  const newLoadingComponent =
    isLoading && createLoadingComponent(loadingComponent)
  const newDropdownComponent = createDropDownComponent(config[id], component)
  const newComponent = createComponent(config[id], component)
  const newCalculatingComponent =
    isCalculating && createCalculatingComponent(config[id])

  return enabled ? (
    <div className={`field ${className}`}>
      {newLabel}
      {newLoadingComponent ||
        newCalculatingComponent ||
        newDropdownComponent ||
        newComponent}
      {errorMsg}
    </div>
  ) : null
}
